<template>
	<span class="am-icon"
		:class="[
			`am-icon--${size}`,
			`am-icon--${theme}`,
			`icon icon-${name}`,
			{ 'is-dark': dark }
		]"
	>
	</span>
</template>

<script>
export default {
	props: {
		name: {
			type: String,
			default: 'user'
		},
		dark: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'md'
		},
		theme: {
			type: String,
			default: 'primary'
		}
	}
}
</script>

<style lang="scss">
.am-icon{
	line-height: 70%;
	// Themes
	&--primary{
		color: #99887F;
		&.is-dark{
			color: white;
		}
	}
	&--secondary{
		color: $t-secondary;
		&.is-dark{
			color: white;
		}
	}

	// Sizes
	&--xs{
		font-size: 12px;
	}
	&--sm{
		font-size: 16px;
	}
	&--md{
		font-size: 24px;
	}
	&--lg{
		font-size: 28px;
	}
	&--xl{
		font-size: 34px;
	}

	&.icon-play{
		transform: translateX(2px);
	}
}
</style>
